import type { StaticDataRouteOption } from "@tanstack/react-router"

import { AppNavigation } from "../NavigationView/AppNavigation"
import { ProjectDashboardViewTopBar } from "./TopBar"

export const projectDashboardViewStaticData: StaticDataRouteOption = {
	leftSlideOut: AppNavigation,
	topBar: ProjectDashboardViewTopBar,
	hideRightSlideOut: true,
}
